import React from "react"
import { Typography } from "@mui/material"
import TaskAltIcon from "@mui/icons-material/TaskAlt"

import  { AssistSoon, CheckIcon, Sent, ThankYou } from "./styles/SubmittedFormStyles"

function SubmittedForm() {
    

    return (
        <>
            <Typography align="center" sx={CheckIcon}>
                <TaskAltIcon fontSize="large" sx={{ color: "#DF7A00" }} />
            </Typography>
            <Typography variant="h2" align="center" sx={ThankYou}>
                Thank you!
            </Typography>
            <Typography align="center" sx={Sent}>
                Your submission has been sent.
            </Typography>
            <Typography align="center" sx={AssistSoon}>
                Technology Services will assist you shortly.
            </Typography>
        </>
    )
}

export default SubmittedForm
